import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import moment from 'moment';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '../../../../../util/date-util';
import GoCardFooterVer2 from '@/shared/cards/footer/go-card-footer-v2.vue';
import { makeReportTypeText } from '../../../../../util/common-util';
import LoadingReportCardComponent from '@/shared/cards/loading-card/loading-report-card/loading-report-card.vue';

@Component({
  methods: { makeReportTypeText, formatDateAgo },
  components: {
    'resource-footer': ResourceFooterComponent,
    'go-card-footer-v2': GoCardFooterVer2,
    'loading-report-card-component': LoadingReportCardComponent,
  },
  computed: {
    moment() {
      return moment;
    },
    isContentNew() {
      return this.formModel && this.formModel.isNew;
    },
  },
})
export default class ReportWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  private imagePath = '@/../content/images/';
  private reportFailedImg = this.imagePath + 'images_v3/common/go-empty-thumb-sz176.png';

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  get source() {
    const userKey = this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser')).id;
    return this.formModel.owner_user_key === userKey ? 'me' : 'others';
  }

  get isIndepthDaily() {
    return this.formModel?.originParentDocDetail?.media_type?.[1] === 'INDEPTH_DAILY';
  }

  onImageError() {
    // Vue.set(this.formModel, 'thumbnail', undefined);
    Vue.set(this.formModel, 'thumbnail', this.reportFailedImg);
  }
}
